import React from "react";

import IconButton from "components/IconButton";

import removeIcon from "components/assets/images/school_money/item-remove.svg";

export default class RemoveButton extends React.Component {
  
  render() {
    return (
      <IconButton src={removeIcon} {...this.props} />
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/RemoveButton.js